const heroSection = $('#hero-section');
const heroModelImage = heroSection.find('.hero-model-image');

let modelAnimationTL;
let modelLoaded = false;

const addImagesFollow = () => {
  const followImages = heroSection.find('.hero-section-follow-image');
  const aspect = $(window).height() / $(window).width();
  const maxImages = 7;
  const minClientX = window.innerWidth / 5;
  const minClientY = window.innerHeight / 5;
  const maxClientX = window.innerWidth - minClientX;
  const maxClientY = window.innerHeight - minClientY;
  let zIndex = 0;
  let lastMove = 0;
  let lastImageIndex = 0;
  let lastClientX = 0;
  let lastClientY = 0;

  heroSection.on('mousemove', function () {
    const visibleCount = followImages.filter(function () {
      return $(this).css('opacity') != '0';
    }).length;
    if (visibleCount > maxImages) {
      const firstImageIndex = (lastImageIndex - maxImages + followImages.length) % followImages.length;
      const isFirstPrev = lastImageIndex > firstImageIndex;
      let elementsToHide;
      if (isFirstPrev) {
        const stillVisibleElements = followImages.slice(firstImageIndex, lastImageIndex);
        elementsToHide = followImages.not(stillVisibleElements);
      } else {
        elementsToHide = followImages.slice(lastImageIndex, firstImageIndex);
      }
      gsap.set(elementsToHide, { opacity: 0, scale: 0, overwrite: 'auto' });
    }

    const followImagesWidth = followImages.eq(lastImageIndex).outerWidth();
    const followImagesHeight = followImages.eq(lastImageIndex).outerHeight();
    const changeX = lastClientX - clientX;
    const changeY = lastClientY - clientY;

    const module = Math.abs(changeX) > followImagesWidth / 1.5 || Math.abs(changeY) > followImagesHeight / 2;
    const isUpperLayer = changeX > 0;
    if (module) {
      const currentImage = followImages.eq(lastImageIndex);
      const scale = 1;
      gsap.fromTo(
        currentImage,
        {
          left: lastClientX,
          top: lastClientY,
          opacity: 1,
          scale: scale,
          zIndex: isUpperLayer ? 1000 + zIndex : 2100 + zIndex,
        },
        {
          left: clientX,
          top: clientY,
          opacity: 1,
          scale: scale,
          zIndex: isUpperLayer ? 1000 + zIndex : 2100 + zIndex,
          duration: 0.633,
          overwrite: true,
        }
      );
      gsap.to(currentImage, {
        opacity: 0,
        scale: 0,
        duration: 1,
        ease: 'pageInEasing',
        delay: 1,
        onComplete: () => {
          const index = followImages.index(currentImage);
          if (index == lastImageIndex) {
            zIndex = 0;
          }
        },
      });
      lastClientX = clientX;
      lastClientY = clientY;
      lastImageIndex = (lastImageIndex + 1) % followImages.length;
      zIndex += 1;
    }
    lastMove += 1;
  });
};

const addHeroGradient = (duration) => {
  const blobFraming = {
    blob1: {
      position: {
        type: '2f',
        currentValue: [-0.5, 0.5],
        frames: [{ frame: 0, value: [-0.5, 0.5] }],
      },
      size: {
        type: '1f',
        currentValue: 0.4,
        frames: [{ frame: 0, value: 0.4 }],
      },
      scale: {
        type: '1f',
        currentValue: 1,
        frames: [{ frame: 0, value: 1 }],
      },
      angle: {
        type: '1f',
        currentValue: 0,
        frames: [{ frame: 0, value: 0 }],
      },
      smooth_step: {
        type: '1f',
        currentValue: 0.6,
        frames: [{ frame: 0, value: 0.6 }],
      },
      color: {
        type: '4f',
        currentValue: [0.051, 0.0666, 0.165, 1],
        frames: [{ frame: 0, value: [0.051, 0.0666, 0.165, 1] }],
      },
    },
    blob2: {
      position: {
        type: '2f',
        currentValue: [1, 1],
        frames: [
          { frame: 0, value: [1.1, -0.1] },
          { frame: 100, value: [1.1, -0.1] },
        ],
      },
      size: {
        type: '1f',
        currentValue: 0.3,
        frames: [{ frame: 0, value: 0.3 }],
      },
      scale: {
        type: '1f',
        currentValue: 1,
        frames: [{ frame: 0, value: 1 }],
      },
      angle: {
        type: '1f',
        currentValue: 0,
        frames: [{ frame: 0, value: 0 }],
      },
      smooth_step: {
        type: '1f',
        currentValue: 0.6,
        frames: [{ frame: 0, value: 0.6 }],
      },
      color: {
        type: '4f',
        currentValue: [0.051, 0.0666, 0.165, 1],
        frames: [{ frame: 0, value: [0.051, 0.0666, 0.165, 1] }],
      },
    },
    blob3: {
      position: {
        type: '2f',
        currentValue: [0.6, 0.2],
        frames: [{ frame: 0, value: [0.6, 0.2] }],
      },
      size: {
        type: '1f',
        currentValue: 0.2,
        frames: [{ frame: 0, value: 0.2 }],
      },
      scale: {
        type: '1f',
        currentValue: 1,
        frames: [{ frame: 0, value: 1 }],
      },
      angle: {
        type: '1f',
        currentValue: 0,
        frames: [{ frame: 0, value: 0 }],
      },
      smooth_step: {
        type: '1f',
        currentValue: 0.7,
        frames: [{ frame: 0, value: 0.7 }],
      },
      color: {
        type: '4f',
        currentValue: [0.408, 0.588, 0.702, 1],
      },
    },
    blob4: {
      position: {
        type: '2f',
        currentValue: [0.5, 0.2],
        frames: [{ frame: 0, value: [0.5, 0.2] }],
      },
      size: {
        type: '1f',
        currentValue: 0.2,
        frames: [{ frame: 0, value: 0.3 }],
      },
      scale: {
        type: '1f',
        currentValue: 2,
        frames: [{ frame: 0, value: 2 }],
      },
      angle: {
        type: '1f',
        currentValue: -40,
        frames: [{ frame: 0, value: -40 }],
      },
      smooth_step: {
        type: '1f',
        currentValue: 0.4,
        frames: [{ frame: 0, value: 0.4 }],
      },
      color: {
        type: '4f',
        currentValue: [0.408, 0.588, 0.702, 1],
        frames: [{ frame: 0, value: [0.408, 0.588, 0.702, 1] }],
      },
    },
  };
  const gradientTL = gsap.timeline({
    duration: duration,
    paused: true,
    onUpdate() {
      const progress = gradientTL.progress();
      gradientAPI.updateGradientSettingsByFrame(progress, blobFraming, 100);
    },
  });
  return gradientTL;
};

const addHeroAnimation = () => {
  const heroTL = gsap.timeline({
    paused: true,
    onComplete: () => {
      $(window).trigger('heroReady');
      /*
      if (isDesktop() && !isLowEndDevice) {
        addImagesFollow();
      }
      */
    },
  });
  const heroDescription = heroSection.find('.hero-description');
  const heroTitle = heroSection.find('.hero-title');
  const heroDescriptorCard = heroSection.find('.descriptor-card');
  const heroBtn = heroSection.find('.button-parent');
  const lineParent = heroSection.find('.hero-line-parent');
  const scrollHandler = heroSection.find('.scroll-handle');

  heroTL.addLabel('step1');
  heroTL.add(addLineAnimation(lineParent, 0.55, 0.701, 0.8646).play(), 'step1+=0.87');
  heroTL.add(addBigTitleAnimation(heroTitle, 150, 0.9, 0.15).play(), 'step1+=0.5');
  heroTL.add(addElementInAnimation(heroDescription, '1000%', 0.9, 0).play(), 'step1+=0.5');
  isDesktop() ? heroTL.add(addElementInAnimation(scrollHandler, '200%', 0.667, 0).play(), 'step1+=0.95') : false;
  heroTL.add(addDescriptorCardAnimation(heroDescriptorCard, '100%', 0.667, 0).play(), 'step1+=0.9');
  heroTL.add(addBtnAnimation(heroBtn).play(), 'step1+=1.5');
  heroTL.add(headerAnimation(true, 0.6, 0.01).play(), 'step1+=2.13');
  return heroTL;
};

const addModelFollowCursor = (scene, model) => {
  let firstFollow = true;
  const deltaAngle = 25;
  const deltaRad = (deltaAngle * Math.PI) / 180;

  const $el = $(heroSection);
  const offset = $el.offset();
  const width = $el.width();
  const height = $el.height();
  const centerX = offset.left + width / 2;
  const centerY = offset.top + height / 2;

  let lastX = 0,
    lastY = 0;
  let ticking = false;

  const handleMove = (e) => {
    lastX = e.pageX;
    lastY = e.pageY;

    if (!ticking) {
      requestAnimationFrame(updateRotation);
      ticking = true;
    }
  };

  const updateRotation = () => {
    ticking = false;

    const dx = lastX - centerX;
    const dy = lastY - centerY;

    const normX = dx / (width / 2);
    const normY = dy / (height / 2);

    const clampedX = Math.max(-1, Math.min(1, normX));
    const clampedY = Math.max(-1, Math.min(1, normY));

    const offsetX = clampedY * deltaRad;
    const offsetY = -clampedX * deltaRad;

    gsap.to(scene.rotation, {
      x: offsetX,
      z: offsetY,
      duration: firstFollow ? 0.8 : 0.4,
      overwrite: 'auto',
      onUpdate: () => scene.queueRender(),
      onComplete: () => {
        firstFollow = false;
      },
    });

    if (firstFollow) {
      gsap.to(model.rotation, {
        x: 0,
        y: (Math.PI / 4) * 3,
        z: 0,
        duration: 0.8,
        onUpdate: () => scene.queueRender(),
      });
    }
  };

  heroSection.on('mousemove', handleMove);
};

const addheroModelImageAnimation = (duration) => {
  const heroModelImageTL = gsap.timeline({ paused: true });
  heroModelImageTL.add(
    gsap.fromTo(
      heroModelImage,
      {
        y: '6vw',
        x: '100vw',
      },
      {
        y: '6vw',
        x: '0vw',
        duration: duration,
        ease: 'pageInEasing',
      }
    ),
    0
  );
  heroModelImageTL.add(
    gsap.fromTo(
      heroModelImage,
      {
        scale: 0.6,
      },
      {
        scale: 0.85,
        duration: 0.85,
        ease: 'modelScaleEasing',
      }
    ),
    duration - 0.7
  );

  return heroModelImageTL;
};

const addModelAnimation = (scene, duration) => {
  const modelScaleEasing = CustomEase.create('modelScaleEasing', '0.74, 0.0, 0.26, 1.0');
  const model = scene.model;
  const modelPlacer = heroSection.find('.model-placer');
  gsap.set(modelPlacer, {
    x: '100vw',
    y: '8vw',
  });
  //model.position.set(4, 0, 0.4);
  scene.model.rotation.set(-Math.PI / 2, Math.PI / 2, 0);
  const modelTL = gsap.timeline({
    paused: true,
    onUpdate: () => scene.queueRender(),
    onComplete: () => {
      if (isDesktop() && !isLowEndDevice) {
        addModelFollowCursor(scene, model);
      }
    },
  });

  modelTL.add(
    gsap.to(modelPlacer, {
      x: 0,
      duration: duration,
      ease: 'pageInEasing',
    }),
    0
  );
  modelTL.add(
    gsap.to(model.rotation, {
      x: baseRotation.x,
      y: baseRotation.y,
      z: baseRotation.z,
      duration: duration,
      ease: 'pageInEasing',
    }),
    0
  );
  modelTL.add(
    gsap.to(modelPlacer, {
      scale: 1.2,
      duration: 0.85,
      ease: 'modelScaleEasing',
    }),
    duration - 0.7
  );

  return modelTL;
};

const playModelAnimation = () => {
  if (!modelAnimationTL) return;
  modelAnimationTL.play();
};

const addHomeHeroModel = () => {
  const modelAttachments = {
    'strap loop': {
      isVisible: true,
      nodesNames: ['activ-strap-loop'],
      changeDisable: [],
      nodes: [],
    },
    'Rounded Pad': {
      isVisible: false,
      nodesNames: ['pad-top-cover', 'pad-locker', 'pad-lock-cover', 'pad-lock-circle'],
      changeDisable: ['Arched Pad'],
      nodes: [],
    },
    'Arched Pad': {
      isVisible: false,
      nodesNames: ['archer-pad-lock', 'archer-pad-inner-cover', 'archer-pad-cover'],
      changeDisable: ['Rounded Pad', 'Comfort Pack'],
      nodes: [],
    },
    'Comfort Pack': {
      isVisible: false,
      nodesNames: ['archer-pad-comfort'],
      changeDisable: ['Arched Pad'],
      nodes: [],
    },
  };
  const modelViewer = heroSection.find('model-viewer');
  heroModelImage.css('display', 'none');
  modelViewer.attr('src', 'https://cdn.jsdelivr.net/gh/eugene-activbody/activeforce_data/3d_model/device-3d.glb');
  if (!isDesktop()) {
    modelViewer.attr('camera-orbit', `0deg 0deg 4m`);
    modelViewer.attr('camera-target', `0m 0m 0m`);
    if (isTablet()) {
      modelViewer.attr('camera-orbit', `0deg 0deg 5.8m`);
      modelViewer.attr('camera-target', `0m 0m 0.2m`);
    }
  }
  const modelViewerControls = undefined;

  addModelViewer(modelAttachments, modelViewer, modelViewerControls)
    .then((scene) => {
      modelAnimationTL = addModelAnimation(scene, 2);
      modelLoaded = true;
      if (heroTL.progress() >= 0.64 / heroTL.duration()) {
        playModelAnimation();
      }
    })
    .catch((err) => {});
};

const heroTL = addHeroAnimation();
if (!isLowEndDevice) {
  addHomeHeroModel();
}

$(window).on('load', function () {
  const [nav] = performance.getEntriesByType('navigation');
  if (!isLowEndDevice) {
    heroTL.add(addHeroGradient(heroTL.duration()).play(), 0);
    heroTL.add(() => {
      if (modelLoaded) {
        playModelAnimation();
      }
    }, 'step1+=0.64');
  } else {
    heroTL.add(addheroModelImageAnimation(2).play(), 'step1+=0.64');
  }
  pageIn(heroTL, nav, 0, true);
});
